/**
 * Shared export plumbing — deliberately DOM-capture-free so the vector
 * export path (exportSvg.ts) never drags modern-screenshot into headless
 * consumers. exportPng.ts layers the raster capture on top.
 */

/** slate-950 (Islands canvas) — matches the board void. Both export formats
 *  frame against it so PNG and SVG output look identical. */
export const BG = "#131314";

export interface ExportFocalOptions {
  /** Filename including extension. */
  readonly filename?: string;
  /** Device-pixel-ratio multiplier. Default 1. */
  readonly scale?: number;
  /** Padding (in item-space px) around the focal frame on every side. */
  readonly padding?: number;
}

export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke on next tick so the click has time to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
